/* Hiba Italian Silky Crepe selector loader + strict 103-color qualification v3.2.2 */
(function () {
  'use strict';

  var TARGET_HANDLE = 'italian-silky-crepe-fabric';
  var V30_CORE = 'hiba-color-family-v30-core.js';
  var V31_CORE = 'hiba-color-family-v31-core.js';
  var THIRD_SOURCE = 'hiba-color-family-third-source.js';
  var THIRD_SOURCE_ORDER = 'hiba-color-family-third-source-order.js';
  var QUALIFIED_TARGET = 103;
  var INVALID_COLORS = {
    'C#21': true,
    'C#15': true,
    'C#205': true,
    'C#41': true,
    'C#2': true,
    'C#4': true,
    'C#27N': true,
    'C#26N': true,
    'C#145N': true,
    'C#108N': true
  };
  var currentSrc = document.currentScript && document.currentScript.src;
  var observer;
  var timer = 0;

  if (!currentSrc) return;
  var cleanSrc = currentSrc.split('?')[0];

  function assetUrl(filename) { return cleanSrc.replace(/hiba-color-family\.js$/, filename); }
  function currentHandle() {
    var productInfo = document.querySelector('product-info[data-product-handle]');
    if (productInfo && productInfo.dataset.productHandle) return String(productInfo.dataset.productHandle);
    var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }
  function loadScript(src, done) {
    var script = document.createElement('script');
    script.src = src;
    script.async = false;
    script.onload = done || function () {};
    script.onerror = done || function () {};
    document.head.appendChild(script);
  }
  function canonical(value) { return String(value || '').toUpperCase().replace(/\s+/g, ''); }
  function labelFor(input) {
    if (!input) return null;
    if (input.labels && input.labels.length) return input.labels[0];
    if (input.id) { try { return document.querySelector('label[for="' + CSS.escape(input.id) + '"]'); } catch (e) {} }
    return input.nextElementSibling && input.nextElementSibling.tagName === 'LABEL' ? input.nextElementSibling : null;
  }
  function countVisiblePills(picker) {
    var count = 0;
    picker.querySelectorAll('input[data-hiba-option-role="color"]').forEach(function (input) {
      var label = labelFor(input);
      if (!label || label.hidden) return;
      if (window.getComputedStyle(label).display === 'none') return;
      count += 1;
    });
    picker.dataset.hibaColorPillCount = String(count);
    picker.dataset.hibaQualifiedColorTarget = String(QUALIFIED_TARGET);
    picker.dataset.hibaQualifiedColorCountOk = count === QUALIFIED_TARGET ? 'true' : 'false';
    window.__hibaItalianCrepeVisibleColorCount = count;
    window.__hibaItalianCrepeQualifiedColorTarget = QUALIFIED_TARGET;
    return count;
  }
  function enforceQualifiedColors() {
    if (currentHandle() !== TARGET_HANDLE) return;
    document.querySelectorAll('[data-hiba-high-variant-picker]').forEach(function (picker) {
      picker.querySelectorAll('input[data-hiba-option-role="color"]').forEach(function (input) {
        var key = canonical(input.dataset.optionValue || input.value);
        if (!INVALID_COLORS[key]) return;
        var label = labelFor(input);
        if (label) label.remove();
        input.remove();
      });
      countVisiblePills(picker);
    });
    window.__hibaItalianCrepeSelectorVersion = '3.2.2';
    window.__hibaItalianCrepeInvalidColors = Object.keys(INVALID_COLORS);
  }
  function scheduleEnforce() { clearTimeout(timer); timer = window.setTimeout(enforceQualifiedColors, 20); }
  function bootQualificationFilter() {
    enforceQualifiedColors();
    window.setTimeout(enforceQualifiedColors, 100);
    window.setTimeout(enforceQualifiedColors, 350);
    window.setTimeout(enforceQualifiedColors, 800);
    window.setTimeout(enforceQualifiedColors, 1500);
    window.setTimeout(enforceQualifiedColors, 2500);
    var root = document.querySelector('main') || document.body;
    if (root && !observer) {
      observer = new MutationObserver(scheduleEnforce);
      observer.observe(root, { childList: true, subtree: true });
    }
    document.addEventListener('shopify:section:load', function () { window.setTimeout(enforceQualifiedColors, 50); });
  }

  /* Store-wide mobile media layout, loaded on every product page through this common asset. */
  (function loadStorewideMobileGalleryCss() {
    if (document.getElementById('hiba-storewide-mobile-gallery-css')) return;
    var link = document.createElement('link');
    link.id = 'hiba-storewide-mobile-gallery-css';
    link.rel = 'stylesheet';
    link.href = assetUrl('hiba-storewide-mobile-gallery.css') + '?v=20260915-storewide-mobile-v1';
    document.head.appendChild(link);
  })();

  loadScript(assetUrl(V30_CORE) + '?v=hibacore30', function () {
    if (currentHandle() !== TARGET_HANDLE) return;
    loadScript(assetUrl(V31_CORE) + '?v=hibacore31', function () {
      loadScript(assetUrl(THIRD_SOURCE) + '?v=20260915-third24-v1', function () {
        loadScript(assetUrl(THIRD_SOURCE_ORDER) + '?v=20260915-media-order-v1', bootQualificationFilter);
      });
    });
  });
})();

/* Load the dedicated 24-color fix only for the new Silky Italian Crepe product. */
(function () {
  'use strict';
  var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
  var handle = match ? decodeURIComponent(match[1]) : '';
  if (handle !== 'silky-italian-crepe-fabric') return;
  var current = document.currentScript && document.currentScript.src;
  if (!current) return;
  var clean = current.split('?')[0];
  var src = clean.replace(/hiba-color-family\.js$/, 'hiba-silky-italian-crepe-fix.js');
  if (src === clean) return;
  var script = document.createElement('script');
  script.src = src + '?v=20260915-silky24-v1';
  script.async = false;
  document.head.appendChild(script);
})();

/* Load the Lurex Product 2 native-intercept bridge only on the customer-facing host. */
(function () {
  'use strict';
  var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
  var handle = match ? decodeURIComponent(match[1]) : '';
  if (handle !== 'premium-lurex-italiano-metallic-fabric') return;
  var current = document.currentScript && document.currentScript.src;
  if (!current) return;
  var clean = current.split('?')[0];
  var src = clean.replace(/hiba-color-family\.js$/, 'hiba-p2-mobile-lurex-fix.js');
  if (src === clean) return;
  var script = document.createElement('script');
  script.src = src + '?v=20260915-lurex-native-intercept-v4';
  script.async = false;
  document.head.appendChild(script);
})();

/* Milano mobile: suppress the stale native gallery underneath the active color gallery. */
(function () {
  'use strict';
  var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
  var handle = match ? decodeURIComponent(match[1]) : '';
  if (handle !== 'milano-matte-sandwashed-silky-fabric') return;
  var current = document.currentScript && document.currentScript.src;
  if (!current) return;
  var clean = current.split('?')[0];
  var src = clean.replace(/hiba-color-family\.js$/, 'hiba-milano-mobile-duplicate-guard.js');
  if (src === clean) return;
  var script = document.createElement('script');
  script.src = src + '?v=20260915-milano-mobile-dup-v1';
  script.async = false;
  document.head.appendChild(script);
})();
